import ButtonDivider from "../../components/ButtonDivider";
import styles from "./Mods.module.css";
import { FaCloudDownloadAlt } from "react-icons/fa";

import steedie_contraband from "../../assets/images/modThumbnails/steedie_contraband.webp";
import steedie_moshpit from "../../assets/images/modThumbnails/steedie_moshpit.webp";
import steedie_plateau from "../../assets/images/modThumbnails/steedie_plateau.webp";
import steedie_contrabandHD from "../../assets/images/modThumbnails/steedie_contrabandHD.webp";
import steedie_kfc from "../../assets/images/modThumbnails/steedie_kfc.webp";
import mason_inferno from "../../assets/images/modThumbnails/mason_inferno.webp";
import steedie_wedgeRV from "../../assets/images/modThumbnails/steedie_wedgeRV.webp";
import steedie_contrabandRV from "../../assets/images/modThumbnails/steedie_contrabandRV.webp";
import steedie_moshpitHD from "../../assets/images/modThumbnails/steedie_moshpitHD.webp";
import steedie_ads from "../../assets/images/modThumbnails/steedie_ads.webp";
import steedie_contraminiRV from "../../assets/images/modThumbnails/steedie_contraminiRV.webp";
import steedie_goofy from "../../assets/images/modThumbnails/steedie_goofy.webp";

// const mods = [
//   {
//     name: "steedie_contraband",
//     dls: "430K",
//     date: "2 May 2020",
//     img: steedie_contraband,
//     link: "https://mod.io/g/mordhau/m/steedie-contraband",
//   },
//   {
//     name: "steedie_moshpit",
//     dls: "237K",
//     date: "1 Oct 2020",
//     img: steedie_moshpit,
//     link: "https://mod.io/g/mordhau/m/steedie-moshpit",
//   },
//   {
//     name: "steedie_plateau",
//     dls: "8K",
//     date: "12 Jul 2023",
//     img: steedie_plateau,
//     link: "https://mod.io/g/mordhau/m/steedie-plateau",
//   },
//   {
//     name: "steedie_contrabandHD",
//     dls: "31K",
//     date: "26 Jun 2023",
//     img: steedie_contrabandHD,
//     link: "https://mod.io/g/mordhau/m/steedie-contrabandhd",
//   },
//   {
//     name: "steedie_kfc",
//     dls: "10K",
//     date: "9 Sept 2023",
//     img: steedie_kfc,
//     link: "https://mod.io/g/mordhau/m/steedie-kfc",
//   },
//   {
//     name: "mason_inferno",
//     dls: "5K",
//     date: "19 Apr 2024",
//     img: mason_inferno,
//     link: "https://mod.io/g/mordhau/m/mason-inferno",
//   },
//   {
//     name: "steedie_wedgeRV",
//     dls: "5K",
//     date: "6 Feb 2024",
//     img: steedie_wedgeRV,
//     link: "https://mod.io/g/mordhau/m/steedie-wedgerv",
//   },
//   {
//     name: "steedie_contrabandRV",
//     dls: "5K",
//     date: "27 Jan 2024",
//     img: steedie_contrabandRV,
//     link: "https://mod.io/g/mordhau/m/steedie-contrabandrv",
//   },
//   {
//     name: "steedie_moshpitHD",
//     dls: "18K",
//     date: "30 Jun 2023",
//     img: steedie_moshpitHD,
//     link: "https://mod.io/g/mordhau/m/steedie-moshpithd",
//   },
//   {
//     name: "steedie_ads",
//     dls: "17K",
//     date: "27 Feb 2024",
//     img: steedie_ads,
//     link: "https://mod.io/g/mordhau/m/steedie-ads",
//   },
//   {
//     name: "steedie_contraminiRV",
//     dls: "4K",
//     date: "2 Feb 2024",
//     img: steedie_contraminiRV,
//     link: "https://mod.io/g/mordhau/m/steedie-contraminirv",
//   },
//   {
//     name: "steedie_goofy",
//     dls: "2K",
//     date: "8 Sept 2023",
//     img: steedie_goofy,
//     link: "https://mod.io/g/mordhau/m/steedie-goofy",
//   },
// ];

const og = [
  {
    name: "steedie_contraband",
    dls: "430K",
    date: "2 May 2020",
    img: steedie_contraband,
    link: "https://mod.io/g/mordhau/m/steedie-contraband",
  },
  {
    name: "steedie_moshpit",
    dls: "237K",
    date: "1 Oct 2020",
    img: steedie_moshpit,
    link: "https://mod.io/g/mordhau/m/steedie-moshpit",
  },
];

const hd = [
  {
    name: "steedie_contrabandHD",
    dls: "31K",
    date: "26 Jun 2023",
    img: steedie_contrabandHD,
    link: "https://mod.io/g/mordhau/m/steedie-contrabandhd",
  },
  {
    name: "steedie_moshpitHD",
    dls: "18K",
    date: "30 Jun 2023",
    img: steedie_moshpitHD,
    link: "https://mod.io/g/mordhau/m/steedie-moshpithd",
  },
];

const rv = [
  {
    name: "steedie_wedgeRV",
    dls: "5K",
    date: "6 Feb 2024",
    img: steedie_wedgeRV,
    link: "https://mod.io/g/mordhau/m/steedie-wedgerv",
  },
  {
    name: "steedie_contrabandRV",
    dls: "5K",
    date: "27 Jan 2024",
    img: steedie_contrabandRV,
    link: "https://mod.io/g/mordhau/m/steedie-contrabandrv",
  },
  {
    name: "steedie_contraminiRV",
    dls: "4K",
    date: "2 Feb 2024",
    img: steedie_contraminiRV,
    link: "https://mod.io/g/mordhau/m/steedie-contraminirv",
  },
];

const special = [
  {
    name: "steedie_kfc",
    dls: "10K",
    date: "9 Sept 2023",
    img: steedie_kfc,
    link: "https://mod.io/g/mordhau/m/steedie-kfc",
  },
  {
    name: "mason_inferno",
    dls: "5K",
    date: "19 Apr 2024",
    img: mason_inferno,
    link: "https://mod.io/g/mordhau/m/mason-inferno",
  },
  {
    name: "steedie_goofy",
    dls: "2K",
    date: "8 Sept 2023",
    img: steedie_goofy,
    link: "https://mod.io/g/mordhau/m/steedie-goofy",
  },
  {
    name: "steedie_plateau",
    dls: "8K",
    date: "12 Jul 2023",
    img: steedie_plateau,
    link: "https://mod.io/g/mordhau/m/steedie-plateau",
  },
];

const other = [
  {
    name: "steedie_ads",
    dls: "17K",
    date: "27 Feb 2024",
    img: steedie_ads,
    link: "https://mod.io/g/mordhau/m/steedie-ads",
  },
];

function Mod({ name, dls, date, img, link }) {
  return (
    <a
      className={styles.card}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <h1>{name}</h1>
      <img src={img} alt={name + " Thumbnail"} />
      <div className={styles.insideCard}>
        <div className={styles.info}>
          <div className={styles.downloads}>
            <FaCloudDownloadAlt />
            <p>{dls}</p>
          </div>
          <p>{date}</p>
        </div>
      </div>
    </a>
  );
}

function Mods() {
  return (
    <div className={styles.mods}>
      <ButtonDivider text={"OG"} />
      <div className={styles.modsContainer}>
        {og.map((m) => (
          <Mod key={m.name} {...m} />
        ))}
      </div>
      <ButtonDivider text={"HD"} />
      <div className={styles.modsContainer}>
        {hd.map((m) => (
          <Mod key={m.name} {...m} />
        ))}
      </div>
      <ButtonDivider text={"REVISITED"} />
      <div className={styles.modsContainer}>
        {rv.map((m) => (
          <Mod key={m.name} {...m} />
        ))}
      </div>
      <ButtonDivider text={"SPECIAL"} />
      <div className={styles.modsContainer}>
        {special.map((m) => (
          <Mod key={m.name} {...m} />
        ))}
      </div>
      <ButtonDivider text={"OTHER"} />
      <div className={styles.modsContainer}>
        {other.map((m) => (
          <Mod key={m.name} {...m} />
        ))}
      </div>
    </div>
  );
}

export default Mods;
